
import Button from '../../../components/base/Button';
import Badge from '../../../components/base/Badge';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/97944226ce66e6b8e083a19386d0338c.jpg')`
      }}
    >
      {/* 吹き出しバッジ */}
      <div className="absolute top-8 right-8 z-10 hidden lg:block">
        <div className="relative bg-yellow-400 text-black p-6 shadow-lg max-w-sm" style={{
          clipPath: 'polygon(0% 0%, 95% 0%, 100% 10%, 95% 20%, 100% 30%, 95% 40%, 100% 50%, 95% 60%, 100% 70%, 95% 80%, 100% 90%, 95% 100%, 0% 100%)'
        }}>
          <div className="text-lg font-bold leading-tight">
            ツールプリセッタ・・・<br />
            測るだけの1台より、稼ぐ1台。<br />
            工具長だけ？<br />
            — その瞬間、品質も稼働も取りこぼすリスクが‼
          </div>
          {/* 吹き出しの矢印 */}
          <div className="absolute -bottom-2 left-8 w-0 h-0 border-l-4 border-r-4 border-t-8 border-l-transparent border-r-transparent border-t-yellow-400"></div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <div className="mb-6">
              <h1 className="text-5xl lg:text-7xl font-bold mb-4 leading-tight">
                <span className="text-yellow-400">一発良品×段取り半減</span>
              </h1>
              <p className="text-3xl lg:text-4xl font-semibold text-white mb-2">
                仕上げボーリング最適化なども含め
              </p>
              <p className="text-3xl lg:text-4xl font-semibold text-white">
                ツールプリセッターで"時間＝お金"を取り戻す!!
              </p>
            </div>
            
            <div className="mb-8">
              <p className="text-xl leading-relaxed text-white">
                ZOLLER venturion / smile は、仕上げ用ボーリングバーをはじめとする精密工具の高精度プリセットとデータ自動転送で、試し削りを最小化し、誰が使っても同じ結果に。段取り時間・不良・材料ロスを一気に縮め、品質と利益を同時に引き上げます。
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Button variant="primary" size="lg" onClick={scrollToContact}>
                <i className="ri-search-line mr-2"></i>
                無料：段取り時間・不良コスト "見える化" 診断
              </Button>
              <Button variant="outline" size="lg" onClick={scrollToContact}>
                <i className="ri-file-download-line mr-2"></i>
                事例PDFを受け取る
              </Button>
            </div>
            
            <Button variant="secondary" size="md" onClick={scrollToContact}>
              <i className="ri-calendar-line mr-2"></i>
              デモ予約
            </Button>
          </div>
          
          <div className="flex justify-center lg:justify-end">
            <div className="grid grid-cols-2 gap-6">
              <div className="space-y-6">
                <Badge variant="yellow" size="lg">
                  <div>
                    <div className="text-xl font-bold">70%</div>
                    <div className="text-xs">削減</div>
                  </div>
                </Badge>
                <Badge variant="black" size="lg">
                  <div>
                    <div className="text-lg font-bold">+40-60h</div>
                    <div className="text-xs">/台</div>
                  </div>
                </Badge>
              </div>
              <div className="space-y-6 mt-8">
                <Badge variant="yellow" size="lg">
                  <div>
                    <div className="text-lg font-bold">6h→30min</div>
                    <div className="text-xs">段取り</div>
                  </div>
                </Badge>
                <Badge variant="black" size="lg">
                  <div>
                    <div className="text-xl font-bold">±2μm</div>
                    <div className="text-xs">精度</div>
                  </div>
                </Badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
